// A job-status poll that rides out brief errors. Prod 2026-10-15: one 503 from Cloud Run's
// front end, 10 s into a MatterGen job, made the client mark the row FAILED while the job
// kept generating on the server, and its candidates never reached the run. A 429, a 5xx or
// a network error is retried; any other response (ok, 404, 401...) goes straight back to
// the caller, which keeps its own handling for it.

export const POLL_RETRIES = 5;

export function isTransientPollStatus(status) {
  return status === 429 || (status >= 500 && status <= 599);
}

function wait(ms, signal) {
  return new Promise((resolve, reject) => {
    if (signal?.aborted) { reject(new DOMException('Aborted', 'AbortError')); return; }
    const t = setTimeout(() => { signal?.removeEventListener('abort', onAbort); resolve(); }, ms);
    const onAbort = () => { clearTimeout(t); reject(new DOMException('Aborted', 'AbortError')); };
    signal?.addEventListener('abort', onAbort, { once: true });
  });
}

/**
 * Calls doFetch() up to retries + 1 times, waiting delayMs between attempts, while it
 * returns a transient status or throws a non-abort error. Returns the first response that
 * is not transient, or the last one once the retries run out; rethrows the last error if
 * every attempt threw. An AbortError is never retried.
 */
export async function fetchPollStatus(doFetch, { retries = POLL_RETRIES, delayMs = 1000, signal } = {}) {
  for (let attempt = 0; ; attempt += 1) {
    try {
      const resp = await doFetch();
      if (resp.ok || !isTransientPollStatus(resp.status) || attempt >= retries) return resp;
    } catch (e) {
      if (e?.name === 'AbortError' || attempt >= retries) throw e;
    }
    await wait(delayMs, signal);
  }
}
